import { makeStyles } from "@material-ui/core/styles";

const timeAvailableChartStyle = makeStyles(theme => ({
    container: {
        width: "100%",
        height: "450px",
        padding: "20px 20px 0 40px"
    },
    title: {
        textAlign: "left"
    },
    graphSubrow: {
        display: "flex",
        justifyContent: "space-between"
    },
    dateDiv: {
        textAlign: "left"
    },
    dateFormatSwitch: {
        textAlign: "right"
    },
    titleMargin: {
        marginRight: "5px",
        verticalAlign: "middle"
    },
    tooltip: {
        textAlign: "left",
        border: "1px solid" + theme.palette.primary.main,
        backgroundColor: "white",
        color: "black",
        fontSize: "1em"
    },
    arrow: {
        fontSize: 16,
        width: 17,
        "&::before": {
            border: "1px solid" + theme.palette.primary.main,
            backgroundColor: "#fff",
            boxSizing: "border-box"
        }
    },
    buttonTooltip: {
        padding: 0
    },
    buttonColor: {
        color: theme.palette.primary.main
    }
}));

export default timeAvailableChartStyle;